import {
    gsap
} from "gsap/dist/gsap";
import {
    ScrollTrigger
} from "gsap/dist/ScrollTrigger";
import {
    ScrollToPlugin
} from "gsap/dist/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
let mainContent = document.getElementById('site');
var preLoaderEl = document.querySelector('.preloader');
const headerBar = mainContent.querySelector('#masthead');
var headerBarAnimate = gsap.timeline({
    paused: true, // default is false
    smoothChildTiming: true,
});
headerBarAnimate
    .fromTo(
        headerBar, {
            opacity: 0,
        }, {
            opacity: 1,
        },
    )
    .fromTo(headerBar, {
        scale: 0.95
    }, {
        scale: 1,
        ease: "power3.in",
        duration: 1
    });

document.addEventListener("DOMContentLoaded", function () {

    if (preLoaderEl) {
        setTimeout(function () {
            preLoaderEl.classList.add('hide');
            mainContent.classList.remove('overflow-hidden');
            mainContent.classList.remove('opacity-0');
            mainContent.classList.add('opacity-100');
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }, 1300);
    }
    
    setTimeout(function () {
        headerBarAnimate.play();
        let topOrnament = gsap.timeline({
            paused: true, // default is false
            defaults: { // children inherit these defaults
                duration: 1.5,
                ease: "power2.out"
            },
            smoothChildTiming: true,
        });
        topOrnament
        .fromTo('h1',
        {
            opacity: 0,
            scale: 1.2
        },
        {
            opacity: 1,
            scale: 1,
            duration:.5
        }, '<.1')
        .fromTo('h2',
        {
            opacity: 0,
            scale: 1.2
        },
        {
            opacity: 1,
            scale: 1,
            duration: .5,
            delay: .1
        }, '<.1')
        .fromTo('p',
        {
            opacity: 0,
            scale: 1.2
        },
        {
            opacity: 1,
            scale: 1,
            duration: .5,
            delay: .1
        }, '<.1')
        .play();
    }, 1300)
    })
